module.exports = __webpack_public_path__ + "img/yingxiao.8a0b379d.png";